import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Grid } from "@material-ui/core";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import "moment/locale/es";
import { fetchLocalidades } from "../../../../actions/cbos/localidades";
import { useForm } from "../../../../hooks/useForm";
import { afiliadoStartUpdate } from "../../../../actions/afiliado";
import { finishSpinner, startSpinner } from "../../../../actions/ui/spinner";
import { setActiveStepAdicciones, setAfiliadoSeleccionadoAdicciones, setSolicitudAdicciones } from "../../../../actions/adicciones/adiccionesActions";
import { STEPPER_ADICCIONES } from "../../data/constants";
import { AdiccionesCard } from "../UI/AdiccionesCard";
import ValidatedDatePicker from "../../../compartidos/ValidatedDatePicker";
import { CboLocalidades } from "../../../cbos/CboLocalidades";


export const AdiccionesDatosTitular = ({ integracion, nuevaSolic, adicciones }) => {
  const dispatch = useDispatch();
  const { items: localidadesArray = [] } = useSelector((state) => state.localidades);

  const {
    afiliadoSeleccionado: afiliadoSeleccionadoAdicciones,
  } = useSelector((state) => state.adicciones);

  //const { items: itemsCertificados } = useSelector((state) => state.certificadosAfiliacion);

  //const [certificadoVigente, setCertificadoVigente] = useState({});
  const [dataChange, setDataChange] = useState(false);
  //const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (localidadesArray?.length === 0) dispatch(fetchLocalidades());
  }, [dispatch, localidadesArray]);

  let afiliadoDefault = {
    carnet: "",
    apellido_y_nombre: "",
    fecha_nacimiento: "",
    mail: "",
    celular: "",
    telefono: "",
    calle: "",
    nro: "",
    codigo_postal: "",
    id_localidad: "",
  };

  const [formValues, handleInputChange, , setearValor, , , , , ,] = useForm(
    afiliadoSeleccionadoAdicciones ?? afiliadoDefault
  );

  const {
    carnet,
    apellido_y_nombre,
    fecha_nacimiento,
    fecha_baja,
    sinFichaAfiliacion,
    domiciliosAfiliados: {
      calle,
      nro,
      codigo_postal,
      id_localidad,
      mail,
      celular,
      telefono,
    } = {},
  } = formValues;

  const getAge = () => {
    if (!fecha_nacimiento) return;
    const today = new Date();
    const birthDate = new Date(fecha_nacimiento);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const edad = getAge();

  const handleLocalidadChange = (e) => {
    if (localidadesArray?.length > 0) {
      const localidad = localidadesArray.find(
        (localidad) =>
          parseInt(localidad?.id_localidad) === parseInt(e.target.value)
      );
      setearValor("id_localidad", localidad?.id_localidad);
    }
  };


  const onSubmitHandler = () => {
    //setOpenModal(false);
    if (dataChange) {
      dispatch(afiliadoStartUpdate(formValues));
    } else {
      dispatch(startSpinner());
    }
    
    dispatch(setAfiliadoSeleccionadoAdicciones(formValues));
    dispatch(setActiveStepAdicciones(STEPPER_ADICCIONES.DETALLES_ORDEN));
    if (nuevaSolic) dispatch(setSolicitudAdicciones({ idAfiliado: formValues.id_afiliado }));

    if (!dataChange) dispatch(finishSpinner());
  };

  const openModalHandler = () => {
    onSubmitHandler()
  }

  return (
    <AdiccionesCard width={"75%"}>
      <ValidatorForm onSubmit={openModalHandler} style={{ margin: "1rem 3rem" }}>
        <Grid container spacing={2}>
          <Grid item xs={2}>
            <TextValidator
              fullWidth
              margin="normal"
              label="Nro Afiliado"
              name="carnet"
              value={carnet}
              disabled={true}
              onChange={handleInputChange}
              validators={["required"]}
              errorMessages={["El nro de afiliado es requerido"]}
            />
          </Grid>
          <Grid item xs={4}>
            <TextValidator
              fullWidth
              margin="normal"
              label="Nombre y Apellido"
              name="apellido_y_nombre"
              value={apellido_y_nombre}
              disabled={true}
              onChange={handleInputChange}
              validators={["required"]}
              errorMessages={["El nombre es requerido"]}
            />
          </Grid>
          <Grid item xs={3}>
            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
              <ValidatedDatePicker
                fullWidth={true}
                margin="normal"
                format="dd/MM/yyyy"
                okLabel="Aceptar"
                clearLabel="Limpiar"
                cancelLabel="Cancelar"
                label="Fecha de Nacimiento"
                name="fecha_nacimiento"
                value={
                  fecha_nacimiento !== undefined &&
                    moment(fecha_nacimiento).isValid()
                    ? moment(fecha_nacimiento)
                    : null
                }
                disabled={true}
                onChange={(e) => setearValor(e)}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                validators={["required"]}
                errorMessages={["La fecha de nacimiento es requerida"]}
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={3}>
            <TextValidator
              fullWidth
              margin="normal"
              label="Edad"
              name="edad"
              value={`${edad} AÑOS`}
              disabled={true}
              onChange={handleInputChange}
              validators={["required"]}
              errorMessages={["La edad es requerida"]}
            />
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              margin="normal"
              label="Email"
              name="domiciliosAfiliados.mail"
              value={mail}
              onChange={(e) => {
                handleInputChange(e);
                setDataChange(true);
              }}
              validators={["required", "isEmail"]}
              errorMessages={["El mail es requerido", "El mail es inválido"]}
            />
          </Grid>
          <Grid item xs={3}>
            <TextValidator
              fullWidth
              margin="normal"
              label="Tel. Particular(10 dígitos sin el 0)"
              name="domiciliosAfiliados.telefono"
              value={telefono ?? ''}
              onChange={(e) => {
                handleInputChange(e);
                setDataChange(true);
              }}
              validators={
                celular === ""
                  ? [
                    "required",
                    "isNumber",
                    "maxNumber:9999999999",
                    "minNumber:999999999",
                  ]
                  : ["isNumber", "maxNumber:9999999999", "minNumber:999999999"]
              }
              errorMessages={
                celular === ""
                  ? [
                    "El teléfono es requerido",
                    "Sólo números",
                    "Verifique su teléfono",
                    "Verifique su teléfono",
                  ]
                  : [
                    "Sólo números",
                    "Verifique su teléfono",
                    "Verifique su teléfono",
                  ]
              }
            />
          </Grid>
          <Grid item xs={3}>
            <TextValidator
              fullWidth
              margin="normal"
              label="Tel. Celular(10 dígitos sin 0 ni 15)"
              name="domiciliosAfiliados.celular"
              value={celular ?? ''}
              onChange={(e) => {
                handleInputChange(e);
                setDataChange(true);
              }}
              maxLength="10"
              validators={
                telefono === ""
                  ? [
                    "required",
                    "isNumber",
                    "maxNumber:9999999999",
                    "minNumber:999999999",
                  ]
                  : ["isNumber", "maxNumber:9999999999", "minNumber:999999999"]
              }
              errorMessages={
                telefono === ""
                  ? [
                    "El celular es requerido",
                    "Sólo números",
                    "Verifique su celular",
                    "Verifique su celular",
                  ]
                  : [
                    "Sólo números",
                    "Verifique su celular",
                    "Verifique su celular",
                  ]
              }
            />
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              margin="normal"
              label="Calle"
              name="domiciliosAfiliados.calle"
              value={calle}
              disabled={false}
              onChange={handleInputChange}
            /* validators={["required"]}
            errorMessages={["La calle es requerida"]} */
            />
          </Grid>
          <Grid item xs={1}>
            <TextValidator
              fullWidth
              margin="normal"
              label="Nro"
              name="domiciliosAfiliados.nro"
              value={nro}
              disabled={false}
              onChange={handleInputChange}
              validators={["required"]}
              errorMessages={["El nro es requerido"]}
            />
          </Grid>
          <Grid item xs={2}>
            <TextValidator
              fullWidth
              margin="normal"
              label="Codigo Postal"
              name="domiciliosAfiliados.codigo_postal"
              value={codigo_postal || ""}
              disabled={true}
              onChange={handleInputChange}
              maxLength="4"
            /* validators={[
              "required",
              "isNumber",
              "maxNumber:9999",
              "minNumber:999",
            ]}
            errorMessages={[
              "codigo_postal requerido",
              "Sólo números",
              "Verifique Cod.Postal",
              "Verifique Cod.Postal",
            ]} */
            />
          </Grid>
          <Grid item xs={3}>
            <CboLocalidades
              name="domiciliosAfiliados.id_localidad"
              cp={codigo_postal ? codigo_postal : 0}
              valor={id_localidad}
              disabled={true}
              notRequired={true}
              manejadorInputChange={handleLocalidadChange}
            />
          </Grid>
        </Grid>
        {/*integracion &&
          <Grid container>
            <Grid item xs={12} style={{ marginTop: "1rem" }}>
              <CarritoCertificados
                itemsCertificados={itemsCertificados}
                certificadoVigente={certificadoVigente}
                setCertificadoVigente={setCertificadoVigente}
                idTipoCertificado={TIPO_CERTIFICADOS.DISCAPACIDAD}
              />
            </Grid>
          </Grid>
        */}
        <div
          style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
        >
          <Button
            variant="contained"
            color="secondary"
            style={{ marginRight: "15rem" }}
            onClick={() => {
              dispatch(setActiveStepAdicciones(STEPPER_ADICCIONES.BUSCAR_AFILIADO));
            }}
          >
            Anterior
          </Button>
          <Button
            variant="contained"
            color="primary"
            type='submit'
            disabled={fecha_baja || sinFichaAfiliacion}
          >
            Siguiente
          </Button>
        </div>
        {/*openModal &&
          <Grid item xs={12}>
            <AutorizacionesModalSolicitudesPendientes
              open={openModal}
              closeModalHandler={() => {
                setOpenModal(false);
              }}
              items={items}
              onSubmitHandler={onSubmitHandler}
            />
          </Grid>
        */}
      </ValidatorForm>
    </AdiccionesCard>
  );
};
